// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__9hvHH","addWidgetButton":"Header_addWidgetButton__2SLHS","dashboardTabs":"Header_dashboardTabs__3vg7x","active":"Header_active__3yOsD"};